import React from 'react';
import c from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './PopoverHeadingText.scss';

interface Props {
  className?: string;
  isSubheading?: boolean;
}

/** Our standard popover heading text */
const PopoverHeadingText: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  isSubheading,
  children,
}) => (
  <Heading className={c(s['root'], isSubheading && s['subheading'], className)}>{children}</Heading>
);
PopoverHeadingText.displayName = 'PopoverHeadingText';

export default PopoverHeadingText;
